var map = {
	"./404.svg": "0VJI",
	"./Collection.svg": "A833",
	"./ContractAmount.svg": "6APK",
	"./Ip.svg": "UOPU",
	"./Proportion.svg": "8YKT",
	"./api.svg": "Mz/u",
	"./bug.svg": "dm9c",
	"./build.svg": "CcSC",
	"./button.svg": "awTP",
	"./cardActivation.svg": "M3gV",
	"./cardMaturity.svg": "9pHj",
	"./cardShip.svg": "/OEl",
	"./cascader.svg": "Vo4H",
	"./chart.svg": "qHis",
	"./checkbox.svg": "9b7A",
	"./clipboard.svg": "I03m",
	"./close.svg": "loaY",
	"./code.svg": "j8Uj",
	"./color.svg": "GUy9",
	"./component.svg": "jpfn",
	"./contract.svg": "6TMa",
	"./customer.svg": "4iIe",
	"./dashboard.svg": "Iuzh",
	"./date-range.svg": "kk7A",
	"./date.svg": "1xBr",
	"./dict.svg": "kknj",
	"./documentation.svg": "mL6r",
	"./download.svg": "kLc4",
	"./drag.svg": "6wtt",
	"./druid.svg": "PAJo",
	"./edit.svg": "04SK",
	"./education.svg": "G6Z1",
	"./email.svg": "Jvlx",
	"./example.svg": "MVC2",
	"./exceeded.svg": "/L+5",
	"./excel.svg": "lXC7",
	"./exit-fullscreen.svg": "fXXK",
	"./eye-open.svg": "t7iP",
	"./eye.svg": "oxfE",
	"./finalPayment.svg": "pjSr",
	"./form.svg": "HbpF",
	"./fullscreen.svg": "RvyL",
	"./github.svg": "WQRl",
	"./group.svg": "mak+",
	"./guide.svg": "HLEY",
	"./icon.svg": "Fbfg",
	"./input.svg": "y60P",
	"./international.svg": "353E",
	"./job.svg": "IorB",
	"./language.svg": "uSl1",
	"./link.svg": "kKPj",
	"./list.svg": "95W7",
	"./lock.svg": "EN3V",
	"./log.svg": "RnOJ",
	"./loggedUser.svg": "Y451",
	"./logininfor.svg": "M/g6",
	"./message.svg": "yvAI",
	"./money.svg": "IF5j",
	"./monitor.svg": "rDY3",
	"./nested.svg": "dbH1",
	"./notPaid.svg": "YQ8W",
	"./number.svg": "PiO6",
	"./online.svg": "rvma",
	"./onlineUser.svg": "MyK0",
	"./password.svg": "74Gh",
	"./pdf.svg": "9w3w",
	"./pendingReceipt.svg": "+UaU",
	"./people.svg": "JP5W",
	"./peoples.svg": "JcqQ",
	"./phone.svg": "bDN7",
	"./post.svg": "kF6w",
	"./qq.svg": "igmI",
	"./question.svg": "wtlM",
	"./radio.svg": "EQj+",
	"./rate.svg": "keVZ",
	"./redis.svg": "oFVk",
	"./renewal.svg": "f4ge",
	"./row.svg": "mpXY",
	"./search.svg": "EqOI",
	"./select.svg": "cMwg",
	"./server.svg": "XCKv",
	"./shopping.svg": "R6+o",
	"./shortMessage.svg": "ul40",
	"./simCard.svg": "RkE2",
	"./size.svg": "1o6k",
	"./skill.svg": "sAjw",
	"./slider.svg": "S86h",
	"./star.svg": "rmOC",
	"./swagger.svg": "s8d+",
	"./switch.svg": "wOgh",
	"./system.svg": "fkAr",
	"./tab.svg": "R9fo",
	"./table.svg": "Ai84",
	"./textarea.svg": "0Xlb",
	"./theme.svg": "DYO4",
	"./threshold.svg": "Y0MS",
	"./time-range.svg": "Bj67",
	"./time.svg": "P2ym",
	"./tool.svg": "3T7B",
	"./tree.svg": "MWzf",
	"./treeTable.svg": "6Ez8",
	"./trend.svg": "172I",
	"./upload.svg": "NI+5",
	"./upwardTrend.svg": "1XaC",
	"./used.svg": "bTEn",
	"./user.svg": "EOg8",
	"./validCode.svg": "TcDJ",
	"./wechat.svg": "R0XQ",
	"./zip.svg": "HTd0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 51